"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function initialState() {
  return {
    "class": 'income',
    type: null,
    // 'employment', 'non_employment'
    subType: null,
    // employment subtypes - 'full_time', 'part_time', 'self' --- non-employment subtypes - ''
    interest: null,
    // debtor1, debtor2
    disbursements: [],
    monthlyCalcMethod: null,
    // 'itemize', 'average'
    itemizeInterval: null,
    // NOTE: only if monthly calc is 'itemize' -- 'weekly', 'alternate_weeks', 'twice_monthly', 'monthly', 'year'
    // 'employment' ---
    party: null,
    // Party
    occupation: null,
    // String
    startedAt: null,
    endedAt: null,
    // startedAtToEndedAt: null, // STRING - Generated on output but can provide a string if non-dates
    // 'non_employment' ---
    additionalDescription: null,
    // gov assistance, household contributions need
    cashBased: null // Matters at times if other gov assistance is cash/non-cash based
    // OPTIMIZE: Thinking gross incomes should just extend from income obj
    // gross: {
    //   2017: 0,
    //   2018: 200,
    // },

  };
}

var createIncome = function createIncome(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    id: (0, _v["default"])()
  });
};

var _default = createIncome;
exports["default"] = _default;